import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from './mainViewMixin';
import { mapState } from 'vuex';
import { themesMixin, vuetifyColors } from '../../utils/themes';
import { downloadAttachment, localizeDate as _localizeDate } from '../../utils/vuex';
export default {
  name: 'ViewNiotaClassicDeviceMonitoring',
  mixins: [mainViewMixin, themesMixin],
  data: function data() {
    return {
      accountId: this.$store.state.authentication.tenantId,
      filterAlert: false,
      filterWarning: false,
      filterThreshold: false,
      resetFilter: false,
      filteredList: [],
      gwHasNonEmptyList: false,
      gwVisualizationDialog: false,
      gwAlertNotificationDialog: false,
      tabItem: 'devices'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    headerBG: function headerBG() {
      return './img/consumer.png';
    },
    hasGWMonitoringPermission: function hasGWMonitoringPermission() {
      return this.permissions['IotHub.read'] || this.permissions['all.read'];
    }
  }),
  watch: {
    tabItem: function tabItem() {
      if (this.tabItem === 'tab-gateways') {
        this.filterWarning = true;
        this.filterAlert = true;
      } else {
        this.filterWarning = false;
        this.filterAlert = false;
        this.filterThreshold = false;
      }
    }
  },
  methods: {
    getColor: function getColor(type) {
      return vuetifyColors[type] || this.vuetifyColorHex('info');
    },
    getFilteredList: function getFilteredList(filteredList) {
      this.filteredList = filteredList;
    },
    runCSVExport: function runCSVExport() {
      var list = this.filteredList;

      if (list.length) {
        var date = new Date();
        var header = this.getHeader();
        var body = this.buildCSVBody(list);
        var data = header + body;
        var fileName = "device_monitoring_".concat(date.toISOString(), ".csv");
        downloadAttachment('text/csv', data, fileName);
      } else {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceMonitoring.notFound'), 'error');
      }
    },
    getStatus: function getStatus(device) {
      var status = null;

      if (device.battery_alert_status) {
        status = "".concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.alert'), ": ").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.alertMsg'));
      } else if (!device.battery_alert_status && device.battery_warning_status) {
        status = "".concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.warning'), ": ").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.warningMsg'));
      } else if (!device.battery_alert_status && !device.battery_warning_status && device.threshold > device.packetCount) {
        status = "".concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.alert'), ": ").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.thresholdAlertMsg'));
      }

      return status;
    },
    getAdditionalInformation: function getAdditionalInformation(device) {
      var additionalInformation = null;

      if (device.battery_alert_status) {
        additionalInformation = "".concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.battery'), ": ").concat(device.battery_value.value.toFixed(2), " - ").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.alertLevel'), ": ").concat(device.variable.alert_level);
      } else if (!device.battery_alert_status && device.battery_warning_status) {
        additionalInformation = "".concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.battery'), ": ").concat(device.battery_value.value.toFixed(2), " - ").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.warningLevel'), ": ").concat(device.variable.warning_level);
      } else if (!device.battery_alert_status && !device.battery_warning_status && device.threshold > device.packetCount) {
        additionalInformation = "".concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.sent'), ": ").concat(device.packetCount, " - ").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.threshold'), ": ").concat(device.threshold);
      }

      return additionalInformation;
    },
    getHeader: function getHeader() {
      var header = "".concat(this.$i18n_t('NiotaClassic.Common.table.id'), ",").concat(this.$i18n_t('NiotaClassic.Common.table.title'), ",").concat(this.$i18n_t('NiotaClassic.Common.table.eui'), ",").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.status'), ",").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.additionalInformation'), ",").concat(this.$i18n_t('NiotaClassic.DeviceMonitoring.lastPacket'), ";\n        ");
      return header;
    },
    buildCSVBody: function buildCSVBody(list) {
      var _this = this;

      var body = '';
      list.forEach(function (device) {
        var row = "".concat(device.id, ",").concat(device.title, ",").concat(device.eui, ",").concat(_this.getStatus(device), ",").concat(_this.getAdditionalInformation(device), ",").concat(_this.localizeDate(device.lastPacket), ";\n\n          ");
        body += row;
      });
      return body;
    },
    localizeDate: function localizeDate(item) {
      if (item) {
        return _localizeDate(item);
      }
    },
    pushMapToRouter: function pushMapToRouter() {
      var accountId = this.accountId || this.$store.state.authentication.tenantId;
      this.$router.push("/niota-classic/gw-mgmt/map/".concat(accountId, "/gateways/?monitoring&warning=").concat(this.filterWarning, "&alert=").concat(this.filterAlert));
    }
  }
};